import React from "react";

const PanIndiaCarRental = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}
      <section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Pan India Car Rental Services</h1>
          </div>
        </div>
      </section>

      {/* ===== MAIN CONTENT SECTION ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">
            
            {/* IMAGE */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="/images/gallery/10.jpeg"
                alt="Pan India Car Rental Services"
                className="img-fluid rounded shadow-lg"
              />
            </div>

            {/* CONTENT */}
            <div className="col-lg-6">
              <h2 className="mb-3">
                <span className="text-danger">Pan India</span> Car Rental Services
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. is a professional car rental
                and corporate transportation provider offering seamless
                Pan-India mobility solutions. With operations spanning over
                <strong> 50 cities across India</strong> and physical offices
                in <strong>8 major metro cities</strong>, we deliver reliable,
                scalable, and standardized transport services nationwide.
              </p>

              <p>
                Our services cater to both corporate clients and individual
                travelers, covering everything from chauffeur-driven car
                rentals and airport transfers to long-term corporate leasing
                and outstation travel. Whether your requirement is a single
                city transfer or multi-city movement, our centralized
                operations ensure consistency and quality across locations.
              </p>

              <p>
                Backed by a modern fleet, trained chauffeurs, and 24×7 support,
                Pune Corporate Cars acts as a single trusted mobility partner
                for organizations with Pan-India travel needs, ensuring safety,
                punctuality, and comfort at every step.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== SERVICES OVERVIEW ===== */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Our Pan India Transportation Services</h2>
              <p className="text-muted">
                Comprehensive car rental and corporate mobility solutions
                available across India.
              </p>
            </div>
          </div>

          <div className="row">
            
            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Chauffeur-driven car rentals</li>
                <li className="mb-3">✔ Airport pickup & drop services</li>
                <li className="mb-3">✔ Outstation & intercity travel</li>
                <li className="mb-3">✔ Hourly, daily & monthly rentals</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Corporate & employee transportation</li>
                <li className="mb-3">✔ Event & conference mobility support</li>
                <li className="mb-3">✔ Dedicated account management</li>
                <li className="mb-3">✔ Centralized billing & MIS reporting</li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Why Choose Pune Corporate Cars?</h2>
              <p className="text-muted">
                A dependable Pan-India mobility partner trusted by leading
                organizations.
              </p>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Presence in 50+ cities across India</li>
                <li className="mb-3">✔ Offices in 8 major metro cities</li>
                <li className="mb-3">✔ Uniform service standards nationwide</li>
                <li className="mb-3">✔ Verified, trained & professional chauffeurs</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Wide fleet: Sedans, SUVs & luxury cars</li>
                <li className="mb-3">✔ 24×7 operations & customer support</li>
                <li className="mb-3">✔ Transparent pricing & compliance</li>
                <li className="mb-3">✔ Scalable solutions for growing businesses</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default PanIndiaCarRental;
